// extracted by mini-css-extract-plugin
export var ad = "ad-module--ad--Fs8SY";
export var adhed = "ad-module--adhed--2FHtY";